export default "__VITE_ASSET__ChioZWMZ__"